import { eAlertSeverity, eAlertStatus, eAlertTypeGroup, eTrackedAlertTypeEntity } from './enums';
import { SelectOption } from './interfaces/select-option';
import { TrackedAlertEntity } from './interfaces/alert-entities/tracked-alert-entity';

// Shared by the client and admin alerts pages

export const ALERT_TYPE_GROUP_LABELS: Record<eAlertTypeGroup, string> = {
  [eAlertTypeGroup.SerialNumber]: 'Serial Number',
  [eAlertTypeGroup.Individual]: 'Individual',
  [eAlertTypeGroup.Business]: 'Business'
};

export const ALERT_SEVERITY_OPTIONS: SelectOption[] = [
  { label: 'Low', value: eAlertSeverity.Low },
  { label: 'Medium', value: eAlertSeverity.Medium },
  { label: 'High', value: eAlertSeverity.High },
  { label: 'Severe', value: eAlertSeverity.Severe }
];

export const ALERT_STATUS_OPTIONS: SelectOption[] = [
  { label: 'New', value: eAlertStatus.New },
  { label: 'Assigned', value: eAlertStatus.Assigned },
  { label: 'Resolved', value: eAlertStatus.Resolved }
];

// "Tracked Item" filter; each type shows its own fields in the alerts filter
export const TRACKED_ITEM_OPTIONS: SelectOption[] = [
  { label: 'Serial Number', value: eTrackedAlertTypeEntity.SerialNumber },
  { label: 'Individual', value: eTrackedAlertTypeEntity.Individual },
  { label: 'Business', value: eTrackedAlertTypeEntity.Business }
];

// CSS modifier for the severity/status pills defined in common.css
export function severityClass(severity: eAlertSeverity): string {
  return `alert-pill-${severity.toLowerCase()}`;
}

export function statusClass(status: eAlertStatus): string {
  return `alert-pill-status-${status.toLowerCase()}`;
}

// Human-readable name for whatever the alert is tracking (serial number, person or business)
export function trackedEntityDisplayName(entity?: TrackedAlertEntity | null): string {
  if (!entity) {
    return '';
  }

  switch (entity.trackedAlertEntityTypeID) {
    case eTrackedAlertTypeEntity.SerialNumber:
      return entity.serialNumber ?? '';
    case eTrackedAlertTypeEntity.Business:
      return entity.businessName ?? entity.businessNumber ?? '';
    case eTrackedAlertTypeEntity.Individual:
      return [entity.firstName, entity.middleName, entity.lastName].filter(n => !!n).join(' ');
    default:
      return '';
  }
}

// Whether new alerts are raised about a tracked item. Older APIs don't send isTracked, so fall back to
// the end date, where none means ongoing.
export function isTrackingActive(entity: TrackedAlertEntity): boolean {
  if (entity.isTracked !== undefined) {
    return entity.isTracked;
  }

  return entity.trackingEndDate === undefined || entity.trackingEndDate === null || new Date(entity.trackingEndDate) > new Date();
}
